import React from "react";

export const VerifiedIcon = ({ size = 14 }) => (
  <svg
    className="ms-verified"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role="img"
    aria-label="Verified"
  >
    <path
      d="M12 2l2.4 2.1 3.2-.4.9 3.1 2.8 1.6-1.3 2.9 1.3 2.9-2.8 1.6-.9 3.1-3.2-.4L12 22l-2.4-2.1-3.2.4-.9-3.1-2.8-1.6 1.3-2.9-1.3-2.9 2.8-1.6.9-3.1 3.2.4z"
      fill="currentColor"
    />
    <path
      d="M9 12l2 2 4-4"
      stroke="#fff"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12l5 5L20 7" />
  </svg>
);

export const Avatar = ({ mentor, size = 48 }) => (
  <div
    className={`ms-avatar ms-avatar--${mentor.tone}`}
    style={{
      width: size,
      height: size,
      fontSize: Math.round(size * 0.31),
    }}
    aria-hidden="true"
  >
    {mentor.initials}
  </div>
);

export const Badge = ({ tone = "neutral", children }) => (
  <span className={`ms-badge ms-badge--${tone}`}>{children}</span>
);

// e.g. "Jason Nunez" -> "Jason", "@perdiemplug" -> "perdiemplug"
export const firstName = (mentor) =>
  mentor.name.split(" ")[0].replace("@", "");
